import * as React from 'react';

import { Modal } from 'security-app/components/common';
import EventsEntityTable from 'components/events/EventsEntityTable';

type EventsModalProps = {
  show: boolean;
  onCancel: () => void;
};

const EventsModal = ({ show, onCancel }: EventsModalProps) => {
  const onClose = () => {
    onCancel();
  };

  return (
    <Modal show={show} title="Add Events" onClose={onClose} maxWidth="1200px" closeOnBackdrop>
      <EventsEntityTable />
    </Modal>
  );
};

export default EventsModal;
